
let appRoutes = [
  {
    path: '/login-app',
    name: 'LOGINAPP',
    component: ()=> import('@/views/app/login/index.vue'),
    meta:{
       index:-1,
      iscatch:true
    },
  },
  {
    path: '/register-app',
    name: 'REGISTERAPP',
    component: () => import('@/views/app/login/register.vue'),
    meta:{
      // index:1,
      iscatch:true
    },
  },
  {
    path: '/find-pass-app',
    name: 'FINDPASSAPP',
    component: () => import('@/views/app/login/findPassword.vue'),
    meta:{
      // index:1,
      iscatch:true
    },
  },

  {
    path: '/app-index',
    name: 'AppIndex',
    meta:{
      index:1,
      iscatch:true
    },
    component: () => import('@/views/app/main/index.vue')
  },
  {
    path: '/app-weather',
    name: 'AppWeather',
    meta:{
      index:4,
      iscatch:true
    },
    component: () => import('@/views/app/main/weather-detail.vue')
  },
  {
    path: '/app-personal',
    name: 'AppPersonal',
    meta:{
      index: 13,
      iscatch:true
    },
    component: () => import('@/views/app/personal/personal.vue')
  },
  {
    path: '/app-my-device',
    name: 'AppMainIndexDevice',
    component: () => import('@/views/app/personal/myDevice'),
    meta:{
      index: 11,
      iscatch:true
    },
  },
  {
    path: '/app-personal-place',
    name: 'AppPersonalUsePlace',
    component: () => import('@/views/app/personal/connectDevice'),
    meta:{
      index: 11,
      iscatch:true
    },
  },
  {
    path: '/app-personal-add-manger',
    name: 'AppPersonalAddManger',
    component: () => import('@/views/app/personal/addManger'),
    meta:{
      index: 11,
      iscatch:true
    },
  },
  {
    path: '/app-time',
    name: 'AppTime',
    meta:{
      index:6,
      iscatch:true
    },
    component: () => import('@/views/app/time/index.vue')
  },
  {
    path: '/app-time-add',
    name: 'AppTimeAdd',
    meta:{
      index:7,
      iscatch:true
    },
    component: () => import('@/views/app/time/add.vue')
  },
  // 供应商端
  {
    path: '/app-supplier-home',
    name: 'AppSupplierHomeIndex',
    component: () => import('@/views/app/supplierHome/index'),
    meta:{
      index: 30,
      iscatch:true,
      title: '服务商中心'
    },
  },
  {
    path: '/app-user-info',
    name: 'AppUserInfo',
    component: () => import('@/views/app/login/userInfo'),
    meta:{
      index: 31,
      iscatch:true,
      title: '个人资料'
    },
  },
  {
    path: '/app-use-place',
    name: 'UsePlaceIndex',
    component: () => import('@/views/app/usePlace/index'),
    meta:{
      index: 40,
      iscatch:true,
      title: '使用场所'
    },
  },
  {
    path: '/app-use-place-detail',
    name: 'UsePlaceDetail',
    component: () => import('@/views/app/usePlace/detail'),
    meta:{
      index: 41,
      iscatch:true,
      title: '使用场所详情'
    },
  },
  {
    path: '/app-use-place-add',
    name: 'UsePlaceAddOrEdit',
    component: () => import('@/views/app/usePlace/addOrEdit'),
    meta:{
      index: 42,
      iscatch:true,
      title: '使用场所新增编辑'
    },
  },
  {
    path: '/app-device-warehouse',
    name: 'AppDeviceWarehouse',
    component: () => import('@/views/app/deviceWarehouse/index.vue'),
    meta:{
      index: 50,
      iscatch:true,
      title: '设备库'
    },
  },
  {
    path: '/app-supplier-contact-user',
    name: 'APPSupplierContactUser',
    component: () => import('@/views/app/deviceWarehouse/contactUser'),
    meta:{
      index:51,
      iscatch:true,
      title: '客户绑定'
    },
  },
  {
    path: '/app-supplier-device-control',
    name: 'APPSupplierDeviceControl',
    component: () => import('@/views/app/main/weather-detail.vue'),
    meta:{
      index:51,
      iscatch:true,
      title: '设备控制'
    },
  },
  {
    path: '/app-device-warehouse-detail',
    name: 'AppDeviceWarehouseDetail',
    component: () => import('@/views/app/deviceWarehouse/detail.vue'),
    meta:{
      index: 52,
      iscatch:true,
      title: '设备详情'
    },
  },
  {
    path: '/app-warning-index',
    name: 'AppWarningIndex',
    component: () => import('@/views/app/warning/index.vue'),
    meta:{
      iscatch:true,
      index: 60,
      title: '告警'
    },
  },
  {
    path: '/app-warning-device',
    name: 'AppWarningDevice',
    component: () => import('@/views/app/warning/device.vue'),
    meta:{
      iscatch:true,
      index: 61,
      title: '设备告警'
    },
  },
  {
    path: '/app-warning-log',
    name: 'AppWarningLog',
    component: () => import('@/views/app/warning/log.vue'),
    meta:{
      iscatch:true,
      index: 61,
      title: '告警日志'
    },
  },
  {
    path: '/app-enter-dataBase',
    name: 'AppEnterDataBase',
    component: () => import('@/views/app/enterDataBase/index.vue'),
    meta:{
      iscatch:true,
      index: 70,
      title: '设备入库'
    },
  },
  {
    path: '/iotdealerhome',
    name: 'iotdealerhome',
    meta:{
      // index:1,
      iscatch:true
    },
    component: () => import('@/views/iot/iotdealerhome.vue')
  },
  {
    path: '/iotdealerequ',
    name: 'iotdealerequ',
    meta:{
      // index:2,
      iscatch:true
    },
    component: () => import('@/views/iot/iotdealerequ.vue')
  },
  {
    path: '/iotequecharts',
    name: 'iotequecharts',
    meta:{
      // index:5,
      iscatch:true
    },
    component: () => import('@/views/iot/iotequecharts.vue')
  },
  // {
  //   path: '/qr-demo',
  //   name: 'QrDemo',
  //   component: () => import('@/views/app/qr-code-reader-demo.vue')
  // }
]

export default appRoutes



// WEBPACK FOOTER //
// ./src/router/app.js